import axiosInstance from './http-common';
import {LoginService} from "./LoginService";
import {refreshToken} from "../../redux/actions/ActionApp";
const setup = (store) => {
    axiosInstance.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("tokenMKT");
            if (token) {
                config.headers["Authorization"] = 'Bearer ' + token;  // for Spring Boot back-end
                // config.headers["x-access-token"] = token; // for Node.js Express back-end
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );
    const { dispatch } = store;
    axiosInstance.interceptors.response.use(
        (res) => {
            return res;
        },
        async (err) => {
            const originalConfig = err.config;


            const urlNotAvalaible = ['pre-register', '/register/external', '/register/validactive/'];
            if (urlNotAvalaible.findIndex(x => originalConfig.url === x) === -1 && err.response) {
                // Access Token was expired
                if (err.response.status === 401 && !originalConfig._retry) {
                    originalConfig._retry = true;

                    try {
                        const rs = await axiosInstance.post("/auth", {
                            refreshToken: LoginService.getLocalRefreshToken(),
                        });

                        const { accessToken } = rs.data;

                        dispatch(refreshToken(accessToken));
                        LoginService.updateLocalAccessToken(accessToken);

                        return axiosInstance(originalConfig);
                    } catch (_error) {
                        return Promise.reject(_error);
                    }
                }
            }

            return Promise.reject(err);
        }
    );
};

export default setup;
